<template>
  <div class="display-layout">
    <!--<div class="display-header">
      <div class="d-flex justify-content-between align-items-center w-100 px-3 py-2">
        <div class="header-brand">
          <h2 class="mb-0" style="color:#fff;">Hercor College</h2>
          <div class="subtitle">Express Transaction | Queue Mangement System</div>
        </div>
        <div class="header-time text-end">
          <div class="current-time">{{ currentTime }}</div>
          <div class="current-date">{{ currentDate }}</div>
        </div>
      </div>
    </div>-->

    <main class="display-content">
      <router-view/>
    </main>

    <!--<div class="display-footer">
      <div class="d-flex justify-content-between align-items-center w-100 px-3 py-2">
        <div>Queue Management System</div>
        <div>{{ currentDateTime }}</div>
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
  name: 'DisplayLayout',
  data() {
    return {
      currentTime: '',
      currentDate: '',
      currentDateTime: '',
      clockInterval: null
    }
  },
  mounted() {
    this.updateClock()
    this.clockInterval = setInterval(this.updateClock, 1000)
  },
  beforeUnmount() {
    if (this.clockInterval) {
      clearInterval(this.clockInterval)
    }
  },
  methods: {
    updateClock() {
      const now = new Date()
      
      // Format time: HH:MM:SS
      this.currentTime = now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      })
      
      // Format date: Month DD, YYYY
      this.currentDate = now.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      })
      
      // Combined date-time for footer
      this.currentDateTime = now.toLocaleString('en-US', {
        weekday: 'long',
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      })
    }
  }
}
</script>

<style scoped>
.display-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.display-header {
  background-color: #2C3E50;
  color: white;
  padding: 0.5rem 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.header-brand h2 {
  font-size: 1.5rem;
  font-weight: 600;
}

.subtitle {
  font-size: 0.9rem;
  opacity: 0.8;
}

.header-time {
  text-align: right;
}

.current-time {
  font-size: 1.25rem;
  font-weight: 600;
}

.current-date {
  font-size: 0.9rem;
  opacity: 0.8;
}

.display-content {
  flex: 1;
  overflow-y: auto;
}

.display-footer {
  background-color: #2C3E50;
  color: white;
  font-size: 0.8rem;
  padding: 0.5rem 0;
}
</style> 